import { useRef } from 'react'
import Styles from './MobileActionButton.module.scss'
import { useButton } from '@react-aria/button'
import { Text } from 'blaze-ui/Text/Text'
import { Icon } from 'blaze-ui/icons/Types'

type Props = {
  onPress?: () => void
  label: string
  icon: Icon
}

export const MobileActionButton = ({ onPress, label, icon: Icon }: Props) => {
  const ref = useRef<HTMLButtonElement>(null)
  const { buttonProps } = useButton({ onPress }, ref)

  return (
    <button {...buttonProps} ref={ref} className={Styles.root} disabled>
      <Icon size={20} color="var(--dark-90)" />
      <Text variant="secondary" color="var(--dark-90)">
        {label}
      </Text>
    </button>
  )
}
